// Simple encryption/decryption utilities for URL parameters
// Uses base64 encoding with a simple XOR cipher for basic obfuscation

/**
 * Encrypts an object to a URL-safe string
 * @param {Object} data - Data object to encrypt
 * @param {string} key - Encryption key (simple XOR)
 * @returns {string} - URL-safe encrypted string
 */
export const encryptData = (data, key = 'WowDigital2024') => {
  try {
    // Convert object to JSON string
    const jsonStr = JSON.stringify(data);
    
    // Simple XOR encryption
    let result = '';
    for (let i = 0; i < jsonStr.length; i++) {
      const charCode = jsonStr.charCodeAt(i) ^ key.charCodeAt(i % key.length);
      result += String.fromCharCode(charCode);
    }
    
    // Convert to base64 and make URL safe
    return btoa(result)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  } catch (error) {
    console.error('Encryption error:', error);
    return '';
  }
};

/**
 * Decrypts a URL-safe string back to an object
 * @param {string} encryptedStr - Encrypted string to decrypt
 * @param {string} key - Encryption key (same as used for encryption)
 * @returns {Object|null} - Decrypted data object or null if invalid
 */
export const decryptData = (encryptedStr, key = 'WowDigital2024') => {
  try {
    if (!encryptedStr) return null;
    
    // Make base64 safe again
    const base64 = encryptedStr
      .replace(/-/g, '+')
      .replace(/_/g, '/');
    
    // Decode base64
    const encoded = atob(base64);
    
    // XOR decrypt
    let result = '';
    for (let i = 0; i < encoded.length; i++) {
      const charCode = encoded.charCodeAt(i) ^ key.charCodeAt(i % key.length);
      result += String.fromCharCode(charCode);
    }
    
    // Parse JSON
    return JSON.parse(result);
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
};